import Cookies from 'js-cookie';

const EncodedCookies = Cookies.withConverter({
    read: decodeURIComponent,
    write: encodeURIComponent,
});

const BUCKET_COOKIE_NAME = 'bucket';
const ONE_YEAR_IN_DAYS = 365;

type BucketCookieItem = {
    name: string;
    value: unknown;
};

export function readBucketCookieServer(
    cookies: Record<string, string>,
    name: string,
): unknown {
    try {
        const cookieValue = cookies[BUCKET_COOKIE_NAME];
        const hasNonEmptyCookieValue =
            cookieValue && typeof cookieValue === 'string';
        const bucketItems: BucketCookieItem[] = hasNonEmptyCookieValue
            ? JSON.parse(decodeURIComponent(cookieValue))
            : [];
        return bucketItems
            .filter((item) => item.name === name)
            .map((item) => item.value)
            .pop();
    } catch {
        // Do nothing
    }
}

export function readBucketCookieClient(name: string): unknown {
    const cookieValue = EncodedCookies.get(BUCKET_COOKIE_NAME);

    if (typeof cookieValue === 'string') {
        try {
            const bucketItems: BucketCookieItem[] = JSON.parse(cookieValue);
            return bucketItems
                .filter((item) => item.name === name)
                .map((item) => item.value)
                .pop();
        } catch {
            deleteAndThrow();
        }
    }
}

export function writeBucketCookie(name: string, value: unknown) {
    let bucketItems: BucketCookieItem[] = [];

    try {
        const cookieValue = EncodedCookies.get(BUCKET_COOKIE_NAME);

        if (typeof cookieValue === 'string') {
            bucketItems = JSON.parse(cookieValue);
            const item = bucketItems.find((item) => item.name === name);

            if (item) {
                item.value = value;
            } else {
                bucketItems.push({ name, value });
            }
        } else {
            bucketItems = [{ name, value }];
        }
    } catch {
        deleteAndThrow();
    }

    // Clean up duplicate cookie from incorrect previous versions
    EncodedCookies.remove(BUCKET_COOKIE_NAME, { path: '' });

    // Write the new cookie
    EncodedCookies.set(BUCKET_COOKIE_NAME, JSON.stringify(bucketItems), {
        expires: ONE_YEAR_IN_DAYS,
    });
}

function deleteAndThrow() {
    EncodedCookies.remove(BUCKET_COOKIE_NAME);
    throw Error('The cookie value cannot be parsed');
}
